/**
 * ExternalDocLink — external-link anchor styled for inline use in setup-guide copy
 * (e.g. warehouse add-account configure step). Split into its own file so
 * `warehouse-setup-guides.tsx` can stay a data/text module without tripping
 * react-refresh/only-export-components.
 */
import * as React from 'react';

export function ExternalDocLink({ href, children }: { href: string; children: React.ReactNode }): React.JSX.Element {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="font-medium text-primary hover:underline">
      {children}
    </a>
  );
}
